module.exports = __webpack_public_path__ + "static/media/2 samurai tattoo oni hanya demon mask warrior japanese tattoo koi fish waves.1280x1707.123e5c86.webp";